import { getDynamicSetting } from 'utils/dynamicSettings';

const serverUrl = getDynamicSetting('server_url');

const SANDBOX_CONFIG_ENDPOINT = 'sandbox_config/v1';

export const BASE_URL = `${serverUrl}/${SANDBOX_CONFIG_ENDPOINT}`;
